import { useRef } from 'preact/hooks';

import EmojiPicker, { EmojiStyle, Theme, type EmojiClickData } from 'emoji-picker-react';

import type { WidgetLocale } from '../../types/widgetLocale';

import { emojiDataRu } from './EmojiPanel.constants';
import { getEmojiCategories } from './getEmojiCategories';
import { useEmojiPanelClose } from './useEmojiPanelClose';

import styles from './styles.module.css';

interface Props {
  locale: WidgetLocale;
  onEmojiSelect: (data: EmojiClickData) => void;
  onCloseOutside: () => void;
}

export const EmojiPanel = ({ locale, onEmojiSelect, onCloseOutside }: Props) => {
  const panelRef = useRef<HTMLDivElement>(null);

  useEmojiPanelClose(panelRef, onCloseOutside);

  return (
    <div ref={panelRef} className={styles.emojiPanel}>
      <EmojiPicker
        width="100%"
        height={350}
        theme={Theme.LIGHT}
        emojiStyle={EmojiStyle.NATIVE}
        emojiData={locale === 'ru' ? emojiDataRu : undefined}
        categories={getEmojiCategories()}
        searchDisabled
        skinTonesDisabled
        onEmojiClick={onEmojiSelect}
        previewConfig={{ showPreview: false }}
      />
    </div>
  );
};
